export default __webpack_public_path__ + "static/media/createTeamYellow.071df45f.svg";